import { useEffect, useState } from 'react'
import Yasqe from '@triply/yasqe'
import '../../node_modules/@triply/yasgui/build/yasgui.min.css'
import '../../node_modules/@triply/yasqe/build/yasqe.min.css'
import { store } from '../store'
import { useLatest } from '../hooks/use-latest'

export function SparqlEditor(props: {
  value: string
  onBlur: (value: string) => void
  mode: 'update-value' | 'init-value'
  id: string
}) {
  const [yas, setYas] = useState<Yasqe | null>(null)
  const [ref, setRef] = useState<any>(null)

  useEffect(() => {
    if (!ref) return () => {}

    const newYas = new Yasqe(ref)
    // for safety, if not set the default query is any "previous" Yasqe query
    newYas.setValue("")
    setYas(newYas)
    store.dispatch({type: 'ADD_YASQE', data: {id: props.id, yasqe:newYas}})
    return () => store.dispatch({type: 'REMOVE_YASQE', data: props.id})
  }, [ref])

  const {onBlur, value} = props
  const onBlurRef = useLatest(onBlur)

  useEffect(() => {
    if (!yas) return
    yas.on('blur', () => onBlurRef.current(yas.getValue()))
  }, [yas, onBlurRef])

  useEffect(() => {
    if (!yas || props.mode === 'update-value') return
    yas.setValue(props.value)
  }, [yas])

  useEffect(() => {
    if (!yas || props.mode === 'init-value') return
    yas.setValue(props.value)
  }, [yas, props.value, props.mode])

  return <div ref={setRef} id={props.id} />
}
